export default __webpack_public_path__ + "static/media/construction--flat--driveway.9fd50f90.png";